// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 329 ? "resolve" : chunkId) + "." + {"181":"110bf118","289":"9442b9ab","329":"74511ae3","988":"53ba7d47"}[chunkId] + ".css";
};